import 'platform';

export default class utility {
    constructor() {
        this._platformClasses();
        this._blankRemoval();
        this._checkTab();
        this._bindPrintButtons();
        this._editExpressButtonStyle();
    }

    _bindPrintButtons () {
        $('.print-js').click(e => {
            e.preventDefault();
            this.print(e.currentTarget.getAttribute('data-file-src'));
        });
    }

    print (src) {
        let w = window.open(src);
        w.print();
    }

    _platformClasses() {
        $('html').addClass('browser' + '-' + platform.name.toLowerCase().replace(/\s+/g, '-'));
        $('html').addClass('os' + '-' + platform.os.family.toLowerCase().replace(/\s+/g, '-').replace(/[^a-zA-Z 0-9 -]+/g, ''));
        $('html').addClass('browser-version' + '-' + platform.name.toLowerCase().replace(/\s+/g, '-') + '-' + platform.version.toLowerCase().replace(/\s+/g, '-'));
    }

    _blankRemoval() {
        //$('[target="_blank"]').attr('target', '_self');
    }

    _editExpressButtonStyle() {
        $('.maec-form button[type="submit"]').removeClass('btn btn-primary').addClass('ae-button green');
        $('.maec-form').removeClass('hide');
    }

    _checkTab() {
        $('body').on('keyup.tabwatcher', function(e) {
            if (e.which == 9) {
                e.preventDefault();
                $('body').addClass('has-tabbed');
                $('body').off('keyup.tabwatcher')
            }
        });
    }
}